import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import AppService from './app.service.context';

/**
 * Reporting Auth Service
 *
 * This module only provides the auth token fetching functionality.
 * Report list, config, and generation are now handled by the SDK.
 */

/**
 * Fetches auth token from RSOTF API
 * GET ${process.env.REACT_APP_RSOTF_API_URL}/system/reporting/auth-token
 */
export const getAuthToken = async () => {
  const urlBuilder = createUrlBuilder(`/system/reporting/auth-token`);
  const response = await getRequest(AppService, urlBuilder.toString());
  return response;
};
